import TableRow from "./TableRow";

const EmptyTableRow = ({ message }: { message: string }) => (
  <TableRow>
    <p className="col-span-2 text-center italic text-ctb-grey-300">{message}</p>
  </TableRow>
);

export default EmptyTableRow;
